import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { ApiService } from 'src/app/api/api.service';
import { GlobalService } from 'src/app/api/global.service';

@Component({
  selector: 'app-create',
  templateUrl: './create.component.html',
  styleUrls: ['./create.component.scss'],
})
export class CreateComponent implements OnInit {

  @Input() url = "";
  @Input() parent_group: any = null;
  groups: any = [];
  @Input() edit_mode = false;
  @Input() add_group = {
    guid: '',
    title: '',
    colour: '#90ee90',
    description: '',
    parent_guid: '',
  }


  constructor(private apiService: ApiService, public globalService: GlobalService, private modalController: ModalController) { }

  ngOnInit() {
    console.log("Parent Group:", this.parent_group);
    if(this.parent_group) this.add_group.parent_guid = this.parent_group.guid;
    else {
      this.add_group.parent_guid = '';
    } 
    this.GetData();
  }

  async GetData() {
    let data: any = await this.apiService.GetGroups(this.url);
    this.groups = data.data;
  }



  async CreateGroup() {
    let data: any = await this.apiService.post(`groups/${this.url}`,this.add_group);
    this.globalService.presentToastMessage(data.message,data.success);
    this.modalController.dismiss(this.add_group);
  }

  async UpdateGroup() {
    let data: any = await this.apiService.put(`groups/${this.url}/${this.add_group.guid}`,this.add_group);
    this.globalService.presentToastMessage(data.message,data.success);
    this.modalController.dismiss(this.add_group);
  }

  async Close() {
    this.modalController.dismiss(null);
  }



}
